package com.stevdza.san.components

import androidx.compose.runtime.Composable
import com.stevdza.san.models.Likes
import com.stevdza.san.styles.NewLikeSectionStyle
import com.stevdza.san.util.Constants.FONT_FAMILY
import com.stevdza.san.util.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun LikeCard(
    modifier: Modifier = Modifier,
    like: Likes
) {
    Link(
        modifier = NewLikeSectionStyle.toModifier()
            .textDecorationLine(TextDecorationLine.None),
        path = like.url,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        Column(
            modifier = modifier
                .id("columnParent")
                .width(Width.MaxContent)
        ) {
            Box(
                modifier = Modifier
                    .id("boxParent")
                    .fillMaxWidth()
                    .maxWidth(250.px)
                    .margin(40.px)
            ) {
                Image(
                    modifier = Modifier
                        .size(150.px)
                        .objectFit(ObjectFit.Cover),
                    src = like.image,
                    alt = "Like Image"
                )
                Box(
                    modifier = Modifier
                        .id("greenOverlay")
                        .fillMaxHeight()
//                        .backgroundColor(argb(a = 0.5f, r = 0, g = 167, b = 142))
                        ,
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        modifier = Modifier
                            .id("linkIcon")
                            .size(32.px),
                        src = Res.Icon.link,
                        alt = "Link Icon"
                    )
                }
            }
            P(
                attrs = Modifier
                    .id("newLikeTitle")
                    .fillMaxWidth()
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(like.title)
            }
            P(
                attrs = Modifier
                    .id("newLikeDesc")
                    .fillMaxWidth()
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .fontWeight(FontWeight.Normal)
//                    .color(Theme.Secondary.rgb)
//                    .opacity(50.percent)
                    .toAttrs()
            ) {
                Text(like.description)
            }
        }
    }
}